import { z } from 'zod';

export const GDPRUserSchema = z.object({
  results: z.array(
    z.object({
      name: z.string().optional(),
      userId: z.string(),
      platform: z.string(),
      imageURL: z.string().optional(),
    }),
  ),
  totalRecords: z.number(),
});

export const GDPRUserSendSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
});
